const links = [
  {
    title: "Accueil",
    desc: "Retournez à la page d'accueil pour découvrir tous nos services de réparation et motorisation à Strasbourg.",
    href: "/",
    icon: "ri-home-line",
  },
  {
    title: "Zones d'intervention",
    desc: "Nous intervenons dans tout le Bas-Rhin : Strasbourg, Haguenau, Schiltigheim et les autres communes.",
    href: "/zones-d-intervention",
    icon: "ri-map-pin-line",
  },
  {
    title: "Dépannage urgence",
    desc: "Volet bloqué en urgence ? Intervention rapide à Strasbourg et dans le Bas-Rhin.",
    href: "/depannage-urgence",
    icon: "ri-alarm-warning-line",
  },
];

export default function Maillage() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-brand-blue mb-3">
            Vous cherchez une autre prestation ?
          </h2>
          <p className="text-brand-text text-base md:text-lg max-w-2xl mx-auto">
            Explorez nos autres pages ou revenez à l'accueil pour découvrir l'ensemble de nos services.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {links.map((link) => (
            <a
              key={link.title}
              href={link.href}
              className="group bg-brand-light rounded-xl border border-brand-border p-5 md:p-6 hover:border-brand-cyan transition-all flex flex-col"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-brand-light border border-brand-border mb-4">
                <i className={`${link.icon} text-brand-cyan text-lg`}></i>
              </div>
              <h3 className="text-brand-blue text-base font-bold mb-2 group-hover:text-brand-cyan transition-colors">
                {link.title}
              </h3>
              <p className="text-brand-text text-sm leading-relaxed">{link.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}